export default __webpack_public_path__ + "static/media/ps-hand.9827097e.png";